"use client";

import { Button } from "@/components/Button";
import { useDiscuss } from "@/context/DiscussConexts";
import type { ComponentPropsWithoutRef } from "react";

type Args = {
  text: "Обсудить проект" | "Написать нам";
} & ComponentPropsWithoutRef<"button">;

export const ButtonDiscuss = ({ text, ...props }: Args) => {
  const { isFormOpen, openForm } = useDiscuss();

  const handleClick = () => {
    if (!isFormOpen) {
      openForm();
    }
  };

  return (
    <Button
      onClick={handleClick}
      {...props}
      aria-label={text}
      variant={text === "Обсудить проект" ? "primary" : "secondary"}
    >
      {text}
    </Button>
  );
};
